import { ResolveFn } from '@angular/router';
import { inject, makeStateKey, PLATFORM_ID, TransferState } from '@angular/core';
import { isPlatformServer } from '@angular/common';
import { ProviderService } from '../Services/provider.service';
import { TranslateService } from '@ngx-translate/core';

export const initResolver: ResolveFn<any> = async route => {
  let currentTheme: string;
  const platformId = inject(PLATFORM_ID);
  const providerService = inject(ProviderService);
  const transferState = inject(TransferState);
  const translateService = inject(TranslateService);

  const id = route.paramMap.get('id');
  const service_mean = route.paramMap.get('mop');

  if (!id) {
    return null;
  }

  if (!service_mean) {
    return null;
  }
  console.log(id);
  console.log(service_mean);

  const myKey = makeStateKey<any>(id);
  const globalKey = makeStateKey<any>('Gkey');
  if (isPlatformServer(platformId)) {
    try {
      const sessionData = await providerService.retrieveSessionData(id, service_mean);
      transferState.set<any>(myKey, sessionData);
      return {
        ...sessionData,
        service_mean,
      };
    } catch (error) {
      transferState.remove(globalKey);
      console.error(`[InitResolver] Failed to retrieve session data for ${id}:`, {
        id,
        service_mean,
        error:
          error instanceof Error
            ? {
                message: error.message,
                stack: error.stack,
              }
            : error,
      });
      return null;
    }
  } else {
    const stateData = transferState.get(myKey, null);
    if (!stateData) {
      return null;
    }

    //const tmpData = JSON.parse(atob(stateData));
    const tmpData = JSON.parse(
      new TextDecoder().decode(Uint8Array.from(atob(stateData), c => c.charCodeAt(0)))
    );
    console.log('tmpData', tmpData);

    let lang = 'en';
    if (tmpData.customer_language_iso_639_1_code) lang = tmpData.customer_language_iso_639_1_code;
    else if (localStorage.getItem('lang')) lang = localStorage.getItem('lang') ?? 'en';

    const disableStatus = tmpData.disable_status_page;

    if (lang) {
      translateService.setDefaultLang(lang);
      translateService.use(lang);
      localStorage.setItem('lang', lang);
    }

    localStorage.setItem('disableStatus', disableStatus);

    //const darkMode = window.matchMedia('(prefers-color-scheme: dark)').matches;
    const darkMode = tmpData.dark;
    if (darkMode) {
      setTheme('dark');
    } else {
      setTheme('light');
    }

    return {
      ...tmpData,
      service_mean,
    };
  }

  function setTheme(theme: 'light' | 'dark') {
    currentTheme = theme;
    document.documentElement.setAttribute('data-theme', theme);
    localStorage.setItem('theme', theme);
  }
};
